import styled, { css } from "styled-components";
import arrowDownFromLine from "./assets/arrow-down-from-line.svg";
import arrowRightFromLine from "./assets/arrow-right-from-line.svg";

/**
 * Exact Figma SVG exports, masked so they inherit the surrounding text colour
 * (same approach as CanvasActionBar's rail icons). The assets are never edited.
 */
const maskedGlyph = (asset: string) => css`
  display: block;
  background-color: currentColor;
  mask: url("${asset}") center / contain no-repeat;
  -webkit-mask: url("${asset}") center / contain no-repeat;
`;

/** Figma 6590:210662: 16 × 16 arrow, drawn in the colour of its parent. */
export const DrillDownGlyph = styled.span`
  width: 1rem;
  height: 1rem;
  ${maskedGlyph(arrowDownFromLine)}
`;

/** Figma 6590:210665: 16 × 16 arrow, drawn in the colour of its parent. */
export const DrillThroughGlyph = styled.span`
  width: 1rem;
  height: 1rem;
  ${maskedGlyph(arrowRightFromLine)}
`;
